import React, { Fragment, useEffect, useState } from "react";
import './ResizableSidePanel.css'
import {
  ButtonGroup,
  Dropdown,
} from "react-bootstrap";
import CommandCenterService from "../../../../../service/CommandCenterService";
import CustomToolTip from "../../../../CommonComponents/CustomToolTip";
import { downloadFile } from "../../../../CommonComponents/CommonFunctions";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Dialog from "../../../../CommonComponents/Dialog";
import TaskModal from "./TaskQueueTeleModal";

export default function Panel({ taskListQueue, currentTime, dashboardType }) {
  const params = useParams();
  const {
    sat_id,
    truetwin_id,
    scenario_id
  } = params;
  const [isSidebarSmall, setIsSidebarSmall] = useState(true);
  const [selectedTab, setSelectedTab] = useState('TASK QUEUE');

  const [deleteFile, setDeleteFile] = useState<any>({
    isOpen: false,
    name: '',
  });


  const [datastoreFiles, setDatastoreFiles] = useState<any>([])


  const get_truetwin_datastore_files = () => {
    CommandCenterService.getTrueTwinDataStoreFiles(truetwin_id)?.then((data) => {
      if (data.data && data.data?.length > 0) {
        setDatastoreFiles(data.data)
      } else {
        setDatastoreFiles([])
      }
    }).catch((err) => {
      console.error(err);
    });
  }


  const get_true_twin_file_content_from_datastore = (file: any,) => {
    CommandCenterService.getTrueTwinDataStoreFilecontent(truetwin_id, file?.['name'])?.then((data) => {
      if (data && data.data) {
        downloadFile(data?.data, file?.['name'])
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  const delete_file_from_datastore = (file) => {
    const fileType = 'outbound';
    CommandCenterService.deleteFileTrueTwinDataStore(truetwin_id, fileType, file)?.then((data) => {
      if (data && data.data) {
        get_truetwin_datastore_files()
        setDeleteFile({
          isOpen: false,
          name: '',
        })
        toast.success("File deleted successfully")
      }
    }).catch((err) => {
      console.error(err);
      setDeleteFile({
        isOpen: false,
        name: '',
      })
    });
  }



  const toggleLayout = () => {
    setIsSidebarSmall((prevValue) => !prevValue);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null)

  useEffect(() => {
    setSelectedItem(taskListQueue?.['taskList']?.[selectedIndex ?? 0]);
  }, [taskListQueue, selectedIndex])

  const handleTaskClick = (item, index) => {
    setSelectedIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedIndex(null)
    setSelectedItem(null)
    setModalOpen(false);
  };
  return (
    <div className="grid-container">
      <div className={`sidebarTmp ${isSidebarSmall ? "sidebar_small" : ""}`}>
        <div style={{ backgroundColor: "black", zIndex: 999 }} className="p-3 w-100" >
          <div className="pt-4 pb-2">
            {(dashboardType === "summary" || taskListQueue?.['simulation_time_abs']) && (
              (() => {
                const timestamp = new Date((dashboardType === "summary" ? currentTime : taskListQueue['simulation_time_abs']) * 1000);
                const formattedDate = `${timestamp.getUTCFullYear()}-${String(timestamp.getUTCMonth() + 1).padStart(2, '0')}-${String(timestamp.getUTCDate()).padStart(2, '0')} ${String(timestamp.getUTCHours()).padStart(2, '0')}:${String(timestamp.getUTCMinutes()).padStart(2, '0')}:${String(timestamp.getUTCSeconds()).padStart(2, '0')} UTC`;
                return <span style={{ fontFamily: 'monospace' }}>{formattedDate}</span>;
              })()
            )}
          </div>
          {taskListQueue?.['simulation_time_abs'] && <div className="line-divide"></div>}
          <div className="header-btn-list w-auto">
            <button className={`header-tab-btn btn-left  ${selectedTab === 'TASK QUEUE' ? "active" : ""}`} onClick={() => {
              setSelectedTab('TASK QUEUE')
            }}>
              TASK QUEUE
            </button>
            <button className={`header-tab-btn btn-left  ${selectedTab === 'TELEDATA' ? "active" : ""}`} onClick={() => {
              get_truetwin_datastore_files()
              setSelectedTab('TELEDATA')
              setIsSidebarSmall(true)
              closeModal()
            }}>
              TELEDATA
            </button>
          </div>
          {selectedTab === 'TELEDATA' &&
            <div className="w-100 pb-5">
              {datastoreFiles?.length > 0 && datastoreFiles?.map(data => (
                <div key={data?.['name']} className='d-flex w-100 align-items-center py-3 ps-1 justify-content-between'>
                  <span className='fs-14 w-90 text-truncate color-text'>
                    <CustomToolTip title={data?.['name']} placement="top" >
                      {data?.['name']}
                    </CustomToolTip>
                  </span>
                  <ButtonGroup size="sm" className="flex-nowrap px-0">
                    <div className="btn-list more-button">
                      <Dropdown drop="end">
                        <Dropdown.Toggle size="sm" variant="transparent">
                          <i className="fe fe-more-vertical fs-20"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            eventKey="0"
                            onClick={(e) => {
                              e.preventDefault();
                              get_true_twin_file_content_from_datastore(data)
                            }}
                          >
                            Download
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="1"
                            onClick={(e) => {
                              e.preventDefault();
                              setDeleteFile({
                                isOpen: true,
                                name: data?.['name'],
                              })
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </ButtonGroup>
                </div>
              ))}
            </div>
          }
          {(!isSidebarSmall && selectedTab === 'TASK QUEUE') &&
            <div className="d-flex flex-column gap-3 overflow-hidden" style={{ width: '685px' }}>
              <div className="d-flex w-100 align-items-center border rounded-4 py-3 px-5 justify-content-between">
                <strong className="fs-14 w-30 align-items-center justify-content-start d-flex">
                  TASK
                </strong>
                <strong className="fs-14 w-30 align-items-center justify-content-center d-flex">
                  START TIME
                </strong>
                <strong className="fs-14 w-30 align-items-center justify-content-center d-flex">
                  GEO-TRIGGER
                </strong>
              </div>
              <div className="d-flex flex-column gap-2">
                {taskListQueue?.['taskList'] && taskListQueue?.['taskList']?.length > 0 &&

                  taskListQueue?.['taskList']?.map((item, index) => {
                    return (<>
                      <div className="d-flex flex-row" style={{ border: selectedIndex === index ? "1px solid grey" : "", borderRadius: selectedIndex === index ? "5px" : "" }}> {/* Parent container for main div and TaskModal */}
                        <div className="d-flex w-100 align-items-center border-bottom justify-content-between rounded-2"
                          style={{ backgroundColor: item?.['status'] === "active" ? "#ffffff33" : "", borderLeft: item?.['status'] === "active" ? "5px solid #CCF54E" : '', padding: "15px", cursor: 'pointer' }}
                          onClick={() => handleTaskClick(item, index)}
                          title="Click to view task telecommands"
                        >
                          <div className="fs-14 w-30 align-items-center justify-content-start d-flex gap-3">
                            {item?.['status'] === "complete" && <img className="pauseIcon noTop" src={require("../ImgAssets/GreenTickSmallIcon.svg").default} />}
                            {item?.['status'] === "waiting" && <img className="pauseIcon noTop " src={require("../ImgAssets/PendingIcon.svg").default} />}
                            {item?.['status'] === "active" && <img className="pauseIcon noTop rotationIcon" src={require("../ImgAssets/Active.svg").default} />}
                            {item?.['status'] === "Not Completed" && <img className="pauseIcon noTop" src={require("../ImgAssets/Partiallycompleted.svg").default} />}
                            {item?.['status'] === "Not Performed" && <img className="pauseIcon noTop" src={require("../ImgAssets/NotPerfomed.svg").default} />}
                            {item?.type !== "Payload Task" ?
                              <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.3127 1.42135C11.4183 1.6837 11.4189 1.97666 11.3142 2.2394C11.2095 2.50213 11.0077 2.71445 10.7505 2.83228L10.8723 6.82093L11.9581 7.65426C12.068 7.73816 12.1424 7.86031 12.1664 7.99646C12.1905 8.13262 12.1624 8.27285 12.0879 8.38932C12.0134 8.50579 11.8979 8.59001 11.7642 8.62526C11.6305 8.66052 11.4884 8.64423 11.3662 8.57964C10.6199 9.38596 9.6951 9.94923 8.64351 10.0953C7.96285 10.1906 7.25848 10.1069 6.54916 9.83184L6.10824 10.4249L8.71626 12.6212C8.96318 12.829 9.14395 13.0985 9.24426 13.3978H9.28284C9.61904 13.3978 9.89076 13.6436 9.88525 13.9489C9.88525 14.2542 9.61353 14.5001 9.27678 14.5001H1.12367C0.78747 14.5001 0.515755 14.2542 0.515755 13.9489C0.515755 13.6623 0.754952 13.4281 1.0669 13.4005V10.4023C1.06678 10.0961 1.13822 9.79423 1.27551 9.52061C1.41279 9.24699 1.61214 9.00924 1.85762 8.82635C2.10311 8.64345 2.38795 8.52046 2.68941 8.4672C2.99087 8.41393 3.30061 8.43186 3.59391 8.51956L4.02711 7.94857C3.55092 7.33294 3.27259 6.66826 3.1822 5.97547C3.04276 4.90624 3.36022 3.8486 3.95491 2.89787C3.85347 2.80046 3.7931 2.66796 3.78616 2.52749C3.77923 2.38703 3.82626 2.24922 3.91761 2.1423C4.00897 2.03538 4.13775 1.96742 4.27758 1.95235C4.4174 1.93728 4.5577 1.97623 4.66975 2.06123L5.65905 2.82016L9.19466 1.96698C9.16134 1.701 9.22608 1.43199 9.37677 1.2103C9.52746 0.988605 9.75377 0.829419 10.0133 0.762531C10.2729 0.695642 10.548 0.725637 10.7871 0.8469C11.0261 0.968163 11.2133 1.17238 11.3127 1.42135ZM6.22122 3.25115L8.04111 4.64831L9.55952 2.65867C9.50053 2.60646 9.44731 2.54807 9.40079 2.48451L6.22067 3.2517L6.22122 3.25115ZM8.47817 4.98396L10.308 6.38773L10.2022 2.93204C10.1543 2.9282 10.1068 2.9212 10.06 2.91109L8.47817 4.98341V4.98396ZM4.83233 3.57523C4.37654 4.33856 4.18088 5.10962 4.27568 5.83272C4.37654 6.60653 4.82021 7.409 5.80786 8.15305C6.79607 8.8982 7.70381 9.1137 8.49084 9.00402C9.20623 8.90481 9.88635 8.52673 10.4816 7.91054L4.83233 3.57523ZM7.92757 13.3978L3.58674 9.74256C3.46115 9.63669 3.30793 9.56892 3.14511 9.54721C2.9823 9.5255 2.81667 9.55076 2.66773 9.62002C2.51879 9.68928 2.39274 9.79965 2.30441 9.93814C2.21609 10.0766 2.16918 10.2375 2.16919 10.4017V13.3978H7.92757Z" fill="#D8D8D8" />
                              </svg>
                              :
                              <i className={`fa fa-gear ${item?.['status'] === "active" ? 'fa-spin' : ''} fs-16`} ></i>
                            }

                            <div className="d-flex flex-column">
                              <span className="fs-14" title={item?.['taskName']?.length >= 14 ? item?.['taskName'] : null}>{item?.['taskName']?.length >= 14 ? `${item?.['taskName'].substring(0, 14)}...` : item?.['taskName']}</span>
                              <div className="d-flex">
                                {item?.['properties'] && Object.keys(item?.['properties']).length > 0 &&
                                  Object.keys(item?.['properties']).filter(key => !['PayloadId', 'GroundStationId', 'FreqBand', 'ExtraDetails', 'SequenceId'].includes(key)).map((key, index) => {
                                    const propertyValue = item?.['properties']?.[key];
                                    const truncatedValue = item?.type === "Payload Task" ? propertyValue?.length > 6 ? `${propertyValue.substring(0, 6)}...` : propertyValue : propertyValue?.length > 6 ? `${propertyValue.substring(0, 11)}...` : propertyValue;
                                    return (
                                      <React.Fragment>
                                        {truncatedValue && item?.type === "Payload Task" && index > 2 && <span>&nbsp;|&nbsp;</span>}
                                        <strong
                                          className={`fs-14 ${index === 1 ? 'text-warning' : ''}`}
                                          key={key}
                                          title={propertyValue?.length >= 7 ? propertyValue : null}
                                        >
                                          {truncatedValue}
                                        </strong>
                                      </React.Fragment>
                                    );

                                  })}
                              </div>

                            </div>
                          </div>
                          <div className="fs-14 w-30 align-items-center justify-content-center d-flex gap-2">
                            <div className="d-flex flex-column">
                              <span className="fs-14">
                                {new Date(item?.startTime * 1000).getUTCHours().toString().padStart(2, '0')}:{new Date(item?.startTime * 1000).getUTCMinutes().toString().padStart(2, '0')}:{new Date(item?.startTime * 1000).getUTCSeconds().toString().padStart(2, '0')} UTC
                              </span>
                              <strong className={item?.['status'] === "complete" ? "fs-14 text-green" : item?.['status'] === "waiting" ? "fs-14 text-warning" : "fs-14"}>{new Date(item.endTime * 1000).getUTCHours().toString().padStart(2, '0')}:{new Date(item?.endTime * 1000).getUTCMinutes().toString().padStart(2, '0')}:{new Date(item?.endTime * 1000).getUTCSeconds().toString().padStart(2, '0')} UTC</strong>
                            </div>
                          </div>
                          <div className="fs-14 w-30 align-items-center justify-content-start d-flex flex-column">
                            <span className="fs-14">
                              {item?.['geoTrigger'] === "None" ? "-" : item?.['geoTrigger']}
                            </span>
                            <strong className="fs-14" title={item?.['location']}>
                              {item?.['location'] === "N/A"
                                ? ""
                                : item?.['location']?.length > 6
                                  ? `${item?.['location'].substring(0, 6)}...`
                                  : item?.['location']
                              }
                            </strong>
                          </div>
                        </div>
                      </div>
                    </>

                    )
                  })
                }

              </div>
            </div>

          }

          {(isSidebarSmall && selectedTab === 'TASK QUEUE') &&
            <Fragment>
              {taskListQueue?.['taskList'] && taskListQueue?.['taskList']?.length > 0 &&
                taskListQueue?.['taskList']?.map((item) => {
                  return (
                    <Fragment>
                      <div
                        className="fs-16 w-100 align-items-center justify-content-start d-flex gap-3 pb-2 rounded-2"
                        style={{ backgroundColor: item?.['status'] === "active" ? "#ffffff33" : "", borderLeft: item?.['status'] === "active" ? "5px solid #CCF54E" : '', padding: "10px" }}
                      >
                        {item?.['status'] === "complete" && <img className="pauseIcon noTop" src={require("../ImgAssets/GreenTickSmallIcon.svg").default} />}
                        {item?.['status'] === "waiting" && <img className="pauseIcon noTop " src={require("../ImgAssets/PendingIcon.svg").default} />}
                        {item?.['status'] === "active" && <img className="pauseIcon noTop rotationIcon" src={require("../ImgAssets/Active.svg").default} />}
                        {item?.['status'] === "Not Completed" && <img className="pauseIcon noTop" src={require("../ImgAssets/Partiallycompleted.svg").default} />}
                        {item?.['status'] === "Not Performed" && <img className="pauseIcon noTop" src={require("../ImgAssets/NotPerfomed.svg").default} />}

                        {item?.type !== "Payload Task" ?
                          <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.3127 1.42135C11.4183 1.6837 11.4189 1.97666 11.3142 2.2394C11.2095 2.50213 11.0077 2.71445 10.7505 2.83228L10.8723 6.82093L11.9581 7.65426C12.068 7.73816 12.1424 7.86031 12.1664 7.99646C12.1905 8.13262 12.1624 8.27285 12.0879 8.38932C12.0134 8.50579 11.8979 8.59001 11.7642 8.62526C11.6305 8.66052 11.4884 8.64423 11.3662 8.57964C10.6199 9.38596 9.6951 9.94923 8.64351 10.0953C7.96285 10.1906 7.25848 10.1069 6.54916 9.83184L6.10824 10.4249L8.71626 12.6212C8.96318 12.829 9.14395 13.0985 9.24426 13.3978H9.28284C9.61904 13.3978 9.89076 13.6436 9.88525 13.9489C9.88525 14.2542 9.61353 14.5001 9.27678 14.5001H1.12367C0.78747 14.5001 0.515755 14.2542 0.515755 13.9489C0.515755 13.6623 0.754952 13.4281 1.0669 13.4005V10.4023C1.06678 10.0961 1.13822 9.79423 1.27551 9.52061C1.41279 9.24699 1.61214 9.00924 1.85762 8.82635C2.10311 8.64345 2.38795 8.52046 2.68941 8.4672C2.99087 8.41393 3.30061 8.43186 3.59391 8.51956L4.02711 7.94857C3.55092 7.33294 3.27259 6.66826 3.1822 5.97547C3.04276 4.90624 3.36022 3.8486 3.95491 2.89787C3.85347 2.80046 3.7931 2.66796 3.78616 2.52749C3.77923 2.38703 3.82626 2.24922 3.91761 2.1423C4.00897 2.03538 4.13775 1.96742 4.27758 1.95235C4.4174 1.93728 4.5577 1.97623 4.66975 2.06123L5.65905 2.82016L9.19466 1.96698C9.16134 1.701 9.22608 1.43199 9.37677 1.2103C9.52746 0.988605 9.75377 0.829419 10.0133 0.762531C10.2729 0.695642 10.548 0.725637 10.7871 0.8469C11.0261 0.968163 11.2133 1.17238 11.3127 1.42135ZM6.22122 3.25115L8.04111 4.64831L9.55952 2.65867C9.50053 2.60646 9.44731 2.54807 9.40079 2.48451L6.22067 3.2517L6.22122 3.25115ZM8.47817 4.98396L10.308 6.38773L10.2022 2.93204C10.1543 2.9282 10.1068 2.9212 10.06 2.91109L8.47817 4.98341V4.98396ZM4.83233 3.57523C4.37654 4.33856 4.18088 5.10962 4.27568 5.83272C4.37654 6.60653 4.82021 7.409 5.80786 8.15305C6.79607 8.8982 7.70381 9.1137 8.49084 9.00402C9.20623 8.90481 9.88635 8.52673 10.4816 7.91054L4.83233 3.57523ZM7.92757 13.3978L3.58674 9.74256C3.46115 9.63669 3.30793 9.56892 3.14511 9.54721C2.9823 9.5255 2.81667 9.55076 2.66773 9.62002C2.51879 9.68928 2.39274 9.79965 2.30441 9.93814C2.21609 10.0766 2.16918 10.2375 2.16919 10.4017V13.3978H7.92757Z" fill="#D8D8D8" />
                          </svg>
                          :
                          <i className={`fa fa-gear ${item?.['status'] === "active" ? 'fa-spin' : ''} fs-16`} ></i>
                        }
                        <div className="d-flex flex-column">
                          <span className="fs-14" title={item?.['taskName']?.length >= 14 ? item?.['taskName'] : null}>{item?.['taskName']?.length >= 14 ? `${item?.['taskName'].substring(0, 14)}...` : item?.['taskName']}</span>
                          <div className="d-flex">
                            {item?.['properties'] && Object.keys(item?.['properties'])?.length > 0 &&
                              Object.keys(item?.['properties']).filter(key => !['PayloadId', 'GroundStationId', 'FreqBand', 'ExtraDetails', 'SequenceId'].includes(key)).map((key, index) => {

                                const propertyValue = item?.properties[key];
                                const truncatedValue = item?.type === "Payload Task" ? propertyValue?.length > 7 ? `${propertyValue.substring(0, 8)}...` : propertyValue : propertyValue?.length > 6 ? `${propertyValue.substring(0, 11)}` : propertyValue;
                                return (
                                  <React.Fragment>
                                    {truncatedValue && item?.type === "Payload Task" && index > 2 && <span>&nbsp;|&nbsp;</span>}
                                    <strong
                                      className={`fs-14 ${index === 1 ? 'text-warning' : ''}`}
                                      key={key}
                                      title={propertyValue?.length >= 7 ? propertyValue : null}
                                    >
                                      {truncatedValue}
                                    </strong>
                                  </React.Fragment>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                      <div className="line-divide mb-3"></div>
                    </Fragment>)
                })
              }
            </Fragment>
          }
        </div>
      </div>

      {selectedTab === 'TASK QUEUE' && <Fragment>
        {isSidebarSmall ?
          <button className="rightTqButton" onClick={toggleLayout} title="Detail view">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 6 10" fill="none">
              <g transform="scale(-1, 1) translate(-6, 0)">
                <path d="M1.18109 4.99992L4.95005 8.45448C5.03538 8.53271 5.08331 8.63881 5.08331 8.74944C5.08331 8.86008 5.03538 8.96618 4.95005 9.04441C4.86472 9.12264 4.74899 9.16658 4.62832 9.16658C4.50765 9.16658 4.39192 9.12264 4.30659 9.04441L0.216816 5.29488C0.174497 5.25618 0.140922 5.21021 0.118014 5.15959C0.095105 5.10898 0.083313 5.05472 0.083313 4.99992C0.083313 4.94512 0.095105 4.89086 0.118014 4.84024C0.140922 4.78963 0.174497 4.74366 0.216816 4.70496L4.30659 0.955429C4.39192 0.8772 4.50765 0.833252 4.62832 0.833252C4.74899 0.833252 4.86472 0.8772 4.95005 0.955429C5.03538 1.03366 5.08331 1.13976 5.08331 1.25039C5.08331 1.36102 5.03538 1.46713 4.95005 1.54536L1.18109 4.99992Z" fill="#CCF54E" />
              </g>
            </svg>
          </button>
          :
          <button className="leftTqButton" onClick={toggleLayout} title="Collapse view">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 6 10" fill="none">
              <path d="M1.18109 4.99992L4.95005 8.45448C5.03538 8.53271 5.08331 8.63881 5.08331 8.74944C5.08331 8.86008 5.03538 8.96618 4.95005 9.04441C4.86472 9.12264 4.74899 9.16658 4.62832 9.16658C4.50765 9.16658 4.39192 9.12264 4.30659 9.04441L0.216816 5.29488C0.174497 5.25618 0.140922 5.21021 0.118014 5.15959C0.095105 5.10898 0.083313 5.05472 0.083313 4.99992C0.083313 4.94512 0.095105 4.89086 0.118014 4.84024C0.140922 4.78963 0.174497 4.74366 0.216816 4.70496L4.30659 0.955429C4.39192 0.8772 4.50765 0.833252 4.62832 0.833252C4.74899 0.833252 4.86472 0.8772 4.95005 0.955429C5.03538 1.03366 5.08331 1.13976 5.08331 1.25039C5.08331 1.36102 5.03538 1.46713 4.95005 1.54536L1.18109 4.99992Z" fill="#CCF54E" />
            </svg>
          </button>
        }
      </Fragment>}

      <TaskModal open_modal={modalOpen && selectedItem} sidebar_small={isSidebarSmall} task={selectedItem} closeModal={closeModal} />
      <Dialog
        onClick={(event) => {
          if (event) {
            delete_file_from_datastore(deleteFile?.['name'])
            setDeleteFile({
              ...deleteFile,
              isOpen: false,
            })
          } else {
            setDeleteFile({
              isOpen: false,
              name: ''
            })
          }
        }}
        openModel={deleteFile.isOpen} comment={`Are you sure you want to delete this file?`}
      />
    </div>
  );

}
